import styled from '@emotion/styled';
import { Button } from 'antd';

export const ConfirmButton = styled(Button)`
  margin: 32px auto 0px;
  width: 200px;
`;
